import { render, staticRenderFns } from "./BookingSidebarBookingItemCompact.vue?vue&type=template&id=a64f7d40&"
import script from "./BookingSidebarBookingItemCompact.vue?vue&type=script&lang=js&"
export * from "./BookingSidebarBookingItemCompact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports